export default __webpack_public_path__ + "f4954dc1b38cd3a2a91bcf9d5859acde.png";